import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { tA11y } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util/i18n-util';

type Props = {
  children?: React.ReactNode;
  id: number | string;
  value: number | string | null;
};

const TabView = (props: Props) => {
  const { children, value, id, ...other } = props;
  const classes = useStyles();

  return (
    <div
      role="tabpanel"
      hidden={value !== id}
      id={`${tA11y('id.tabView')}-${id}`}
      aria-labelledby={`${tA11y('aria.tabView')}-${id}`}
      {...other}
    >
      {value === id && (
        <Box p={3} className={classes.box}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
};

const useStyles = makeStyles(() => ({
  box: {
    padding: '0px',
  },
}));

export default TabView;
